// extracted by mini-css-extract-plugin
export default {"background":"onboarding_background__QlNOB"};